export default __webpack_public_path__ + "ebf04c4e619b6aaf85b933c8ee23f7ee.woff";